import { Box, Grid, TextField, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Button, InputLabel, FormControlLabel, Checkbox, Typography, Select, MenuItem, FormControl, FormHelperText, Alert } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import KeyboardDoubleArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftOutlined';
import SaveIcon from '@mui/icons-material/Save';
import { useScheduled } from '../../../../shared/context/scheduledContext'
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import { useForm, Controller } from "react-hook-form";
import { useState, useEffect } from "react";
import AddSubTaskComponent from "./AddSubTaskComponent";
import { useUtiles } from "../../../../shared/context/utilesContext";

export default function CreateSubTaskComponent({ readOnly }) {
    const theme = useTheme()
    const { setStepActive, subtaskScheduledList, subtaskScheduled, setSubtaskScheduled, setSubtaskScheduledList, subtaskScheduledValue, setSubtaskScheduledValue, setIndexSubtaskScheduled, resetSubtaskScheduled, taskScheduled } = useScheduled()
    const { control, handleSubmit, formState: { errors } } = useForm()
    const { openSilderWith, saveCurrentComponent } = useUtiles()

    const handleStepBack = () => {
        setStepActive(1)
    }


    


    const handleOpenAddSubTask = () => {
        openSilderWith(<AddSubTaskComponent />, 700, 'Agregar subtarea')
        saveCurrentComponent()
        resetSubtaskScheduled()
    }

    const handleOpenEditSubTask = (subtask, index) => {
        setSubtaskScheduled(subtask)
        setIndexSubtaskScheduled(index)
        openSilderWith(<AddSubTaskComponent />, 700, 'Editar subtarea')
        saveCurrentComponent()
    }


    const handleDeleteSubTask = (index) => {
        const newSubtaskScheduledList = [...subtaskScheduledList]
        newSubtaskScheduledList.splice(index, 1)
        //reordenar las subtareas
        newSubtaskScheduledList.forEach((subtask, i) => {
            subtask.order = i + 1
        })
        setSubtaskScheduledList(newSubtaskScheduledList)
    }



    return (
        <Box sx={{
            padding: '0px 5px',
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'end', gap: '10px', alignItems: 'center', marginTop: '5px', marginBottom: '10px', marginRight: '5px' }}>
               { !taskScheduled.assigned_to_ot && !readOnly && <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleOpenAddSubTask}>Agregar subtarea</Button>}
            </Box>

            {
                taskScheduled.assigned_to_ot && (
                    <Grid item size={{ xs: 12 }}>
                        <Alert severity="warning">La tarea ya esta asignada a una OT, no se puede editar</Alert>
                    </Grid>
                )
            }

            <TableContainer sx={{ maxHeight: 350, minHeight: "350px", width: '100%' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium, width: '100px' }}></TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Orden</TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Descripción</TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Tipo</TableCell>
                            <TableCell sx={{ backgroundColor: theme.palette.background.medium }}>Obligatorio</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {subtaskScheduledList.map((subtask, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <Box sx={{ display: 'flex', gap: '5px' }}>
                                       { !taskScheduled.assigned_to_ot && !readOnly && <IconButton onClick={() => handleOpenEditSubTask(subtask, index)} size="small"><EditNoteOutlinedIcon /></IconButton>}
                                       { !taskScheduled.assigned_to_ot && !readOnly && <IconButton onClick={() => handleDeleteSubTask(index)} size="small"><DeleteOutlineOutlinedIcon /></IconButton>}
                                    </Box>
                                </TableCell>
                                <TableCell>{subtask.order}</TableCell>
                                <TableCell>{subtask.description}</TableCell>
                                <TableCell>{subtask.type_field}</TableCell>
                                <TableCell>{subtask.is_mandatory ? 'SI' : 'NO'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', alignItems: 'center', marginTop: '20px' }}>
                <Button variant="contained" color="primary" startIcon={<KeyboardDoubleArrowLeftOutlinedIcon />} onClick={handleStepBack}>Anterior</Button>

            </Box>

        </Box>
    )
}